import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, canonical, ogImage, keywords }) => {
  return (
    <Helmet>
     
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Horizon Webinfo Pvt Ltd" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta name="keywords" content={keywords.join(', ')} /> 

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@hwplindia" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
     
    </Helmet>
  );
};

export default SEO;
